// extracted by mini-css-extract-plugin
export default {"filterInput":"SearchFilter_filterInput__6Qwsn"};